<dx-data-grid class="eoe-grid"
              [dataSource]="dataSource"
              [hoverStateEnabled]="true"
              [columnAutoWidth]="true"
              [wordWrapEnabled]="true"
              [allowColumnResizing]="true"
              [showRowLines]="true"
              [showBorders]="true"
              (onEditingStart)="onEditingStart($event)"
              (onContentReady)="onContentReady($event)"
              (onToolbarPreparing)="onToolbarPreparing($event)">

    <dxo-search-panel placeholder="Suche..." [width]="300" [visible]="true"></dxo-search-panel>

    <div *dxTemplate="let data of 'interneEoEAnlegenTemplate'">
        <dx-button *ngIf="darfInterneEoEAnlegen" icon="add" type="normal" stylingMode="contained"
                   hint="Interne EoE erstellen" [elementAttr]="{'aria-label': 'Interne EoE erstellen'}"
                   (onClick)="interneEoEAnlegen()"></dx-button>
    </div>

    <div *dxTemplate="let data of 'searchBarTemplate1'">
        <div class="toolBarTemplateContainerSelectbox">
            <div class="dx-field">
                <div class="dx-field-label">Status:</div>
                <div class="dx-field-value">
                    <dx-drop-down-box [dataSource]="available_bearbeitungsStatus"
                                      class="toolBarTemplateItem"
                                      displayExpr="name"
                                      valueExpr="id"
                                      [acceptCustomValue]="true"
                                      [(value)]="selectedBearbeitungsStatus">
                        <div *dxTemplate="let contentData of 'content'">
                            <dx-list [dataSource]="available_bearbeitungsStatus"
                                     selectionMode="multiple"
                                     keyExpr="id"
                                     [showSelectionControls]="true"
                                     (onSelectionChanged)="changeDropDownBoxValue($event)"
                                     [(selectedItemKeys)]="selectedBearbeitungsStatus">
                                <div *dxTemplate="let data of 'item'">
                                    <div>{{data.name}}</div>
                                </div>
                            </dx-list>
                        </div>
                    </dx-drop-down-box>
                </div>
            </div>
        </div>
    </div>

    <div *dxTemplate="let data of 'searchBarTemplate2'">
        <div class="toolBarTemplateContainerSelectbox">
            <div class="dx-field">
                <div class="dx-field-label">Gelesen:</div>
                <div class="dx-field-value">
                    <dx-drop-down-box [dataSource]="available_readStatus"
                                      class="toolBarTemplateItem"
                                      displayExpr="name"
                                      valueExpr="id"
                                      [acceptCustomValue]="true"
                                      [(value)]="selectedReadStatus">
                        <div *dxTemplate="let contentData of 'content'">
                            <dx-list [dataSource]="available_readStatus"
                                     selectionMode="multiple"
                                     keyExpr="id"
                                     [showSelectionControls]="true"
                                     (onSelectionChanged)="changeDropDownBoxValue($event)"
                                     [(selectedItemKeys)]="selectedReadStatus">
                                <div *dxTemplate="let data of 'item'">
                                    <div>{{data.name}}</div>
                                </div>
                            </dx-list>
                        </div>
                    </dx-drop-down-box>
                </div>
            </div>
        </div>
    </div>

    <!-- <div *dxTemplate="let data of 'searchBarTemplate3'">
        <div class="toolBarTemplateContainerCheckbox">
            <div class="dx-field">
                <div class="dx-field-value">
                    <dx-check-box [width]="100" text="auch UEs" [(value)]="useHE"></dx-check-box>
                </div>
            </div>
        </div>
    </div> -->

      <dxo-editing [allowUpdating]="true" [useIcons]="true">
    </dxo-editing>

    <dxo-paging [pageSize]="5"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 50]"
               [showInfo]="true"
               infoText="Seite {0} von {1} Seiten ({2} Datensätze)"
               [showNavigationButtons]="true">
    </dxo-pager>

    <dxo-remote-operations [filtering]="true"
                           [sorting]="true"
                           [paging]="true">
    </dxo-remote-operations>

    <dxo-selection mode="single"></dxo-selection>
    <dxo-state-storing [enabled]="true" [savingTimeout]="200" type="localStorage" storageKey="meldungenEntityEoESuche"></dxo-state-storing>

    <dxi-column dataField="readStatus" caption="Status" [calculateCellValue]="readStatus_calculateCellValue"></dxi-column>
    <dxi-column dataField="bearbeitungsStatus" caption="Bearb. Status" [calculateCellValue]="bearbeitungsStatus_calculateCellValue"></dxi-column>
    <dxi-column dataField="istInternErfasst" caption="Intern erfasst" dataType="boolean" [allowHiding]="false" [allowFiltering]="false" [allowSorting]="false"></dxi-column>
    <dxi-column dataField="schweregrad" caption="Schweregrad" [allowHiding]="false" cellTemplate="schweregradTemplate"></dxi-column>
    <div *dxTemplate="let cell of 'schweregradTemplate'">
        <span [style.color]="cell.data.schweregradFarbe || 'black'">{{cell.value}}</span>
    </div>
    <dxi-column dataType="date" format="dd.MM.yyyy" dataField="meldeDatum" caption="Meldedatum"></dxi-column>
    <dxi-column dataType="date" format="dd.MM.yyyy" dataField="vorkommnisDatum" caption="Vorkommnisdatum"></dxi-column>
    <dxi-column dataField="ort" caption="Ort"></dxi-column>
    <dxi-column dataField="vorkommnisArt" caption="Vorkommnisart" cssClass="eoe-vorkommnisart" width="40%" [minWidth]="240"></dxi-column>

</dx-data-grid>
